import { AscEventName } from '../interfaces/interface.asc-analytics';
import { sendTrackingEvent } from '../services/service.tracking';
import { state as answerState } from '../store/store.answers';
import { populateFromLocal as populateAscFromLocal, setInitialized as setASCInitialized, state as trackingASCState } from '../store/store.tracking-asc';
import { ASC_EVENTS, FIELDS_TO_TEXT, getElementTitle, getFormEngageField } from '../utils/utils.asc-analytics';
import { QUESTION_LEAD_TYPE, QUESTION_MAKE_MODEL, QUESTION_YEAR_RANGE } from '../utils/utils.question';

export const onEngagementInit = (formName: string = '', started: boolean = true) => {
  try {
    populateAscFromLocal();
  } catch (error) {
    console.log('Unable to load ASC tracking from browser store', error);
  }
  // set engagementStarted
  if (trackingASCState[formName]) {
    trackingASCState[formName] = { ...trackingASCState[formName], trackingStarted: started };
  }
  setASCInitialized(true);
};

export const trackFormEngagement = (canonicalName: string = '', answerKey: string = '', answerValue: boolean | string | string[] | number[] | number = '') => {
  for (const trackingForm in trackingASCState) {
    const trackingFormStage = trackingASCState[trackingForm] || {};
    const { trackingStarted, formNames, fields } = trackingFormStage;

    if (!trackingStarted || !formNames?.includes(canonicalName)) {
      continue;
    }
    const action = fields.length > 0 ? 'engage' : 'start';

    let engagedField = `${canonicalName}-${answerKey}`;
    let fieldKey = '';
    if ([QUESTION_YEAR_RANGE, QUESTION_MAKE_MODEL].includes(answerKey)) {
      fieldKey = getFormEngageField(canonicalName, answerKey, answerState, answerValue);
      if (!fieldKey) {
        continue;
      }
      engagedField = `${engagedField}-${fieldKey}`;
    } else if (answerKey === QUESTION_LEAD_TYPE) {
      fieldKey = answerValue.toString();
      engagedField = `${engagedField}-${fieldKey}`;
    } else if (Object.keys(FIELDS_TO_TEXT).includes(answerKey)) {
      fieldKey = answerKey;
    }

    if (!fields.includes(engagedField) || engagedField.includes(QUESTION_LEAD_TYPE)) {
      trackingASCState[trackingForm] = {
        ...trackingFormStage,
        fields: [...fields, engagedField],
      };

      sendEngagementEvent({
        elementText: FIELDS_TO_TEXT[fieldKey] || fieldKey,
        action,
      });
    }
  }
};

export const sendEngagementEvent = (event) => {
  const { action, elementText } = event;
  if (!elementText) {
    return;
  }

  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: action,
    eventResult: `form_engagement::${action}::${elementText}`,
    eventNonInteractive: false,
  });
};

export const eventProperties = (eventName: AscEventName, measurementId: string, eventProps) => {
  const eventCommonProps = {
    send_to: measurementId,
    event_owner: 'kbb',
    event_name: eventName,
    product_name: 'ico',
    page_type: 'trade',
  };

  switch (eventName) {
    case ASC_EVENTS.PAGE_VIEW:
      return {
        ...eventCommonProps,
      };
    case ASC_EVENTS.RETAIL_PROCESS:
      const { flow_outcome } = eventProps;
      return {
        ...eventCommonProps,
        element_title: getElementTitle(eventProps),
        flow_name: 'trade',
        flow_outcome,
      };
    case ASC_EVENTS.CTA_INTERACTION:
      const { element_text, event_action_result } = eventProps;
      return {
        ...eventCommonProps,
        element_text,
        element_type: 'trade_tool',
        event_action: 'click',
        event_action_result,
      };
  }
};
